<template>
  <v-dialog v-model="dialog" max-width="600px">
    <template v-slot:activator="{ on }">
      <v-btn class="mx-2" v-on="on" text small> Select URL </v-btn>
    </template>
    <v-card>
      <v-card-title>Select this URL </v-card-title>
      <v-card-text
        >Are you sure you want to select this URL as new domain ?</v-card-text
      >
      <v-card-actions>
        <v-container class="py-0">
          <v-row class="py-0">
            <v-col class="text-center pt-0">
              <v-btn text @click="dialog = false">
                Cancel
              </v-btn>
              <v-btn color="primary" class="ml-2" @click="submit">
                Save
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { logout } from "../../../../../utils/auth";
export default {
  name: "ImportedFileOptionssBtn",
  props: {
    site: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      dialog: false
    };
  },

  methods: {
    submit() {
      this.dialog = false;
      this.$emit("selectedUrl", this.site);
      this.$store.commit("push", {
        msg: "Domain changed successfully",
        color: "success"
      });
      this.$store.commit("setBaseUrl", JSON.stringify(this.site));
      logout();
    }
  }
};
</script>
